import { Component, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CreditCardInfo } from './models/credit-card-data';
import { CommonModule } from '@angular/common';
import { FormModule, InputMaskType } from '@rogers/cdk/form';
import { PopoverModule } from '@rogers/cdk/popover';
import { CreditCardNumberComponent } from '../credit-card-number/credit-card-number.component';
import { CreditCardNumberInputFormData } from '../credit-card-number/models/credit-card-number-type';

@Component({
  standalone: true,
  selector: 'ucx-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss'],
  imports: [
    FormModule,
    ReactiveFormsModule,
    PopoverModule,
    CommonModule,
    CreditCardNumberComponent,
  ],
})
export class CreditCardComponent implements OnInit {
  @Input() creditCardInfo: CreditCardInfo = {} as CreditCardInfo;
  @Input() creditCardForm: FormGroup;
  inputMasktype = InputMaskType;
  securityCodeLimit = 4;
  creditCarNumberFormData = {} as CreditCardNumberInputFormData;
  get expiryDateControl(): FormControl {
    return this.creditCardForm.get('expiryDate') as FormControl;
  }

  get cvvControl(): FormControl {
    return this.creditCardForm.get('cvv') as FormControl;
  }

  get showExpiryDateError(): boolean {
    return !!this.expiryDateControl?.errors;
  }

  get showCvvError(): boolean {
    return !!this.cvvControl?.errors;
  }

  ngOnInit() {
    this.creditCarNumberFormData = {
      creditCardAltText:
        this.creditCardInfo?.creditCardFormData?.creditCardAltText,
      creditCardErrorMessage:
        this.creditCardInfo?.creditCardFormData?.creditCardErrorMessage,
      creditCardInputLabel:
        this.creditCardInfo?.creditCardFormData?.creditCardInputLabel,
    };
    this.creditCardForm.addControl(
      'expiryDate',
      new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5),
      ])
    );
    this.creditCardForm.addControl(
      'cvv',
      new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(
          this.creditCardForm?.get('creditCardNumber')?.value
            ?.securityCodeLimit || this.securityCodeLimit
        ),
      ])
    );
  }

  validateSecurityCode(): void {
    const cvvLength = this.cvvControl?.value.length;
    if (
      cvvLength < 3 ||
      cvvLength !==
        this.creditCardForm?.get('creditCardNumber')?.value?.securityCodeLimit
    ) {
      if (cvvLength > 1) {
        this.cvvControl?.markAsDirty();
      }
      this.cvvControl?.setErrors({ incorrect: true });
    } else {
      this.cvvControl?.setErrors(null);
    }
  }

  validateDate(): void {
    const expDateVal = (this.expiryDateControl?.value as string) || '';
    if (expDateVal.length > 4 && expDateVal.indexOf('/') !== -1) {
      const expiryDate = expDateVal.split('/');
      const expiryMonth = Number(expiryDate[0]);
      const expiryYear = Number(expiryDate[1]);
      const currentYear = Number(new Date().getFullYear().toString().slice(2));
      const currentMonth = new Date().getMonth() + 1;
      if (
        (expiryMonth < currentMonth && expiryYear <= currentYear) ||
        expiryYear < currentYear
      ) {
        this.expiryDateControl?.setErrors({ incorrect: true });
      } else {
        this.expiryDateControl?.setErrors(null);
      }
    } else {
      this.expiryDateControl?.setErrors({ incorrect: true });
    }
  }
}
